import styled from "styled-components";

export const Wrapper = styled.div`
  position: absolute;
  height: 100%;
  background: #fff;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 4;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 1.7em;
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 95px;
`;

export const Text = styled.div`
  display: flex;
  color: #333;
`;

export const Spinner = styled.img`
  width: 40px;
  height: 40px;
  align-self: center;
`;
